import { r as registerInstance, h, H as Host, g as getElement } from './index-aa456b4c.js';

const fdsTabsItemCss = ".fds-expander__content{display:block;padding:0 1rem 0.75rem;background-color:white;border-bottom-left-radius:16px;border-bottom-right-radius:16px}.fds-expander__content>*:last-child{margin-bottom:0 !important}.fds-expander__content[hidden]{display:none}.fds-tabs__item{text-align:center}.fds-tabs__item button,.fds-tabs__item a,.fds-tabs__item router-link{display:block;cursor:pointer;background-color:transparent;padding:0.75rem 1rem;border-radius:32px;display:inline-block;margin-bottom:0.25rem;font-family:IBM-Plex-Sans-VF, Arial, sans-serif;font-weight:bold;font-size:1rem;line-height:1.5;letter-spacing:0;margin:0.25rem;border:2px solid transparent;user-select:none;transition:box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out, background-color 0.2s ease-in-out;text-decoration:none !important;color:inherit !important;white-space:nowrap}.fds-tabs__item button:focus,.fds-tabs__item button:hover,.fds-tabs__item a:focus,.fds-tabs__item a:hover,.fds-tabs__item router-link:focus,.fds-tabs__item router-link:hover{background-color:rgba(255, 255, 255, 0.59);outline:none}.fds-tabs__item button:active,.fds-tabs__item a:active,.fds-tabs__item router-link:active{border-color:transparent;background-color:rgba(255, 255, 255, 0.795)}.fds-tabs__item button.router-link-exact-active,.fds-tabs__item a.router-link-exact-active,.fds-tabs__item router-link.router-link-exact-active{border-color:transparent;background-color:white;box-shadow:0 4px 8px 0 rgba(12, 72, 153, 0.12)}.fds-tabs__item[active] button,.fds-tabs__item[active] a,.fds-tabs__item[active] router-link{border-color:transparent;background-color:white;box-shadow:0 4px 8px 0 rgba(12, 72, 153, 0.12)}.fds-tabs__item[disabled]{cursor:not-allowed;pointer-events:none;opacity:0.35;user-select:none}";

const FdsTabsItem = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.disabled = false;
    this.active = false;
  }
  /**
   * Watch for the prop disabled and set corresponding attrubutes to the slotted element
   */
  watchDisabled() {
    this.handleDisabled();
  }
  watchActive() {
    this.handleActive();
  }
  componentWillLoad() {
    this.el.children[0].classList.add('fds-tabs__item__el');
    this.handleDisabled();
    this.handleActive();
  }
  /**
   * Handle the disable state of the slotted element.
   */
  handleDisabled() {
    if (this.disabled) {
      this.el.children[0].setAttribute('disabled', '');
    }
    else {
      this.el.children[0].removeAttribute('disabled');
    }
  }
  handleActive() {
    if (this.active) {
      this.el.children[0].setAttribute('active', '');
    }
    else {
      this.el.children[0].removeAttribute('active');
    }
  }
  render() {
    const classes = {
      'fds-tabs__item': true,
      'fds-tabs__item--disabled': this.disabled
    };
    return (h(Host, { class: classes, "aria-disabled": this.disabled ? 'true' : null }, h("slot", null)));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "disabled": ["watchDisabled"],
    "active": ["watchActive"]
  }; }
};
FdsTabsItem.style = fdsTabsItemCss;

export { FdsTabsItem as fds_tabs_item };
